import { jsx as i } from "react/jsx-runtime";
import { c as t } from "react/compiler-runtime";
import { LinearProgress as m } from "@mui/material";
import { forwardRef as a } from "react";
const n = a((e, s) => {
  const r = t(3);
  let o;
  return r[0] !== e || r[1] !== s ? (o = /* @__PURE__ */ i(m, { ref: s, ...e }), r[0] = e, r[1] = s, r[2] = o) : o = r[2], o;
});
n.displayName = "LinearProgress";
export {
  n as LinearProgress
};
